const TAB_OPTIONS = {
  active: "Active",
  archived: "Archived",
};

export default TAB_OPTIONS;
